import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const TestCasesRunTimeInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      This table shows the data of test cases
      runs in the selected monitor configuration.
    </Color>
  </Paragraph>

export default TestCasesRunTimeInfo
